import { render, staticRenderFns } from "./s_AllPayouts.vue?vue&type=template&id=12b8b722&scoped=true&"
import script from "./s_AllPayouts.vue?vue&type=script&lang=js&"
export * from "./s_AllPayouts.vue?vue&type=script&lang=js&"
import style0 from "./s_AllPayouts.vue?vue&type=style&index=0&id=12b8b722&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b8b722",
  null
  
)

export default component.exports